/**
 * Sticky mobile recipe scope-filter bar (Phase 9d)
 *
 * Mobile-only bottom sheet for the /search Recipes-tab scope checkboxes.
 * Sits above the mobile nav footer (bottom: var(--mnf-h, 0px)).
 *
 * State sync: popup checkboxes mirror the inline sidebar checkboxes
 * (data-aro-recipe-scope inside .aro-search-page__panel--recipes).
 * User toggle in popup → also toggles inline → dispatches change event
 * on inline → aro-search-page-recipes.js's existing bind runs
 * (writeSavedScopes + applyScopeFilter).
 *
 * Tab-visibility: body class .aro-rsf--tab-recipes toggled by tab
 * radio changes. CSS uses this + max-width media query to show/hide
 * the bar. Sticky-sort-filter visibility is untouched.
 */
(function () {
  'use strict';

  var SCOPES = ['title', 'description', 'body', 'products'];

  function isOnSearchPage() {
    return /^\/search\/?$/.test(window.location.pathname);
  }

  function findInline(scope) {
    return document.querySelector('.aro-search-page__panel--recipes [data-aro-recipe-scope="' + scope + '"]');
  }

  function findPopup(scope) {
    return document.querySelector('[data-aro-rsf-scope="' + scope + '"]');
  }

  function syncPopupFromInline() {
    SCOPES.forEach(function (s) {
      var inline = findInline(s);
      var popup = findPopup(s);
      if (inline && popup) popup.checked = inline.checked;
    });
  }

  function bindPopupCheckboxes() {
    SCOPES.forEach(function (s) {
      var popup = findPopup(s);
      if (!popup || popup.__aroRsfBound) return;
      popup.__aroRsfBound = true;
      popup.addEventListener('change', function () {
        var inline = findInline(s);
        if (!inline) return;
        inline.checked = popup.checked;
        inline.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function bindOpenClose() {
    var bar = document.getElementById('aro-rsf');
    var popup = document.getElementById('aro-rsf-popup');
    var overlay = document.querySelector('[data-aro-rsf-overlay]');
    if (!bar || !popup || !overlay) return;

    var openBtn = bar.querySelector('[data-aro-rsf-open]');
    var closeBtn = popup.querySelector('[data-aro-rsf-close]');

    function open() {
      syncPopupFromInline();
      popup.hidden = false;
      overlay.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('aro-rsf--open');
    }
    function close() {
      popup.hidden = true;
      overlay.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('aro-rsf--open');
    }

    if (!openBtn.__aroRsfBound) {
      openBtn.__aroRsfBound = true;
      // Toggle: click open when closed, click again to close. Mirrors
      // aro-sf openWhich() toggle behaviour at sticky-sort-filter.js:42.
      openBtn.addEventListener('click', function () {
        if (popup.hidden) open();
        else close();
      });
    }
    if (closeBtn && !closeBtn.__aroRsfBound) {
      closeBtn.__aroRsfBound = true;
      closeBtn.addEventListener('click', close);
    }
    if (!overlay.__aroRsfBound) {
      overlay.__aroRsfBound = true;
      overlay.addEventListener('click', close);
    }
    if (!document.__aroRsfEscBound) {
      document.__aroRsfEscBound = true;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !popup.hidden) close();
      });
    }
    // Any mobile-nav-footer link tap closes the Search-In popup — user is
    // switching context to nav/categories/etc, so a stale popup layered
    // above the aro-mnf popup would be confusing. Mirrors the same hook
    // in sticky-sort-filter.js. Delegated on document so it works
    // regardless of aro-mnf load order.
    if (!document.__aroRsfMnfBound) {
      document.__aroRsfMnfBound = true;
      document.addEventListener('click', function (e) {
        if (e.target.closest('.aro-mnf__link') && !popup.hidden) close();
      });
    }
  }

  function updateTabVisibilityClass() {
    var recipes = document.getElementById('aro-search-page-tab-recipes');
    var products = document.getElementById('aro-search-page-tab-products');
    var isRecipes = !!(recipes && recipes.checked);
    var isProducts = !!(products && products.checked);
    document.body.classList.toggle('aro-rsf--tab-recipes', isRecipes);
    // Hide the Products-scope sticky-sort-filter (#aro-sf) whenever the
    // active tab isn't Products — its Sort options and Filter categories
    // only apply to product results, not blogs or recipes.
    document.body.classList.toggle('aro-search-page--not-products', !isProducts);
  }

  function bindTabWatch() {
    document.querySelectorAll('input[name="aro-search-page-tab"]').forEach(function (r) {
      if (r.__aroRsfTabBound) return;
      r.__aroRsfTabBound = true;
      r.addEventListener('change', updateTabVisibilityClass);
    });
  }

  function showBar() {
    var bar = document.getElementById('aro-rsf');
    if (bar) bar.hidden = false;
  }

  function init() {
    if (!isOnSearchPage()) return;
    showBar();
    bindPopupCheckboxes();
    bindOpenClose();
    bindTabWatch();
    updateTabVisibilityClass();
    syncPopupFromInline();
  }

  // On facet re-render, inline checkboxes are replaced with fresh DOM →
  // re-bind popup change handlers (idempotent via __aroRsfBound flag on
  // popup checkboxes, which persist since popup lives outside the
  // #ProductGridContainer). Re-sync state to match freshly-restored
  // inline state.
  function hookRerender() {
    if (!window.FacetFiltersForm) return false;
    if (FacetFiltersForm.__aroRsfHooked) return true;
    FacetFiltersForm.__aroRsfHooked = true;
    var orig = FacetFiltersForm.renderProductGridContainer;
    if (typeof orig !== 'function') return true;
    FacetFiltersForm.renderProductGridContainer = function (html) {
      orig.call(this, html);
      try {
        syncPopupFromInline();
        bindTabWatch();
        updateTabVisibilityClass();
      } catch (e) { /* silent */ }
    };
    return true;
  }

  function bootstrap() {
    init();
    if (!hookRerender()) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (hookRerender() || tries > 40) clearInterval(iv);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
